export const ANALYTICS_EVENT_BUSINESS = {
  NATURAL_PERSON: 'PF',
};
